module.exports = {"hiddenMessageCode":"*#45","requestUpdateCode":"*#45req=","autoMessageCode":"*#46"}


//////////////////
// WEBPACK FOOTER
// ./src/config/systemMessageCodes.json
// module id = lLkA
// module chunks = 1